import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";

const CargarVenta = ({ productData, show, handleClose }) => {
  const { loadProducts } = useContext(CartContext);
  const [loading, setLoading] = useState(false);
  const [etiquetaFile, setEtiquetaFile] = useState(null);

  const [formData, setFormData] = useState({
    nombre_cliente: "",
    dni: "",
    producto: "",
    marco: "",
    precio: "",
    metodo_pago: "Efectivo",
    nro_operacion: "",
    tarjeta: "",
    od_e: "",
    od_c: "",
    od_a: "",
    oi_e: "",
    oi_c: "",
    oi_a: "",
    add: "",
  });

  // Formatea graduación: 1.5 -> +1.50
  const formatGrad = (val) => {
    if (val === "" || val === null || val === undefined) return "0.00";
    const num = parseFloat(val);
    if (isNaN(num)) return "0.00";
    return (num >= 0 ? "+" : "") + num.toFixed(2);
  };

  // CORRECCIÓN: Permite que el eje 0 se muestre correctamente
  const formatEje = (val) => {
    return val !== "" && val !== null && val !== undefined ? ` x ${val}°` : "";
  };

  useEffect(() => {
    if (productData) {
      setFormData((prev) => ({ ...prev, marco: productData.titulo }));
    }
  }, [productData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setEtiquetaFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const dataToSend = new FormData();
    // Token de seguridad para el backend
    dataToSend.append("auth_token", "OM_VENTAS_2024_SECURE");
    dataToSend.append("id_producto", productData.id);

    // Mapeo de todos los campos del formulario
    Object.keys(formData).forEach((key) => {
      dataToSend.append(key, formData[key] === null ? "" : formData[key]);
    });

    if (etiquetaFile) dataToSend.append("etiqueta_pdf", etiquetaFile);

    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/process_sale.php",
        {
          method: "POST",
          body: dataToSend,
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        const urlDetalleProducto = `https://optimarketok.com.ar/detalle/${productData.id}/`;

        // Armado del mensaje para WhatsApp con los ejes corregidos
        const textoParaCopiar = `✅ *Nueva Venta*

🖼️ *Producto:* ${urlDetalleProducto}

👤 *Cliente:* ${formData.nombre_cliente.toUpperCase()}
👓 *Cristal:* ${formData.producto}

👁️ *OD:* ${formatGrad(formData.od_e)} (${formatGrad(formData.od_c)})${formatEje(formData.od_a)}
👁️ *OI:* ${formatGrad(formData.oi_e)} (${formatGrad(formData.oi_c)})${formatEje(formData.oi_a)}
➕ *ADD:* ${formatGrad(formData.add)}

🗓️ *Entrega:* ${res.fecha_entrega}
📄 *Ficha PDF:* ${res.pdf_url}`;

        Swal.fire({
          title: "¡Venta Registrada!",
          text: "Datos guardados. ¿Copiar para WhatsApp?",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#25D366",
          confirmButtonText: "📋 Copiar Texto",
          cancelButtonText: "Cerrar",
        }).then((result) => {
          if (result.isConfirmed) {
            navigator.clipboard.writeText(textoParaCopiar).then(() => {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "¡Copiado al portapapeles!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
          }
        });

        await loadProducts();
        handleClose();
      } else {
        Swal.fire(
          "Error",
          res.message || "No se pudo procesar la venta",
          "error",
        );
      }
    } catch (err) {
      Swal.fire("Error", "Error de conexión con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>Registrar Venta de Anteojo</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2">
            1. Detalle del Trabajo
          </h6>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label className="fw-bold text-dark">
                Armazón (Marco)
              </Form.Label>
              <Form.Control
                name="marco"
                value={formData.marco}
                readOnly
                className="bg-light"
              />
            </Col>
            <Col md={6}>
              <Form.Label className="fw-bold text-primary">
                Cargar Etiqueta Correo (PDF)
              </Form.Label>
              <Form.Control
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Label>Apellido y nombre</Form.Label>
              <Form.Control
                name="nombre_cliente"
                required
                onChange={handleChange}
                placeholder="Ej: Juan Perez"
              />
            </Col>
            <Col md={6}>
              <Form.Label className="fw-bold text-primary">
                Tipo de Cristales
              </Form.Label>
              <Form.Control
                name="producto"
                required
                onChange={handleChange}
                placeholder="Ej: Orgánico Blue Light"
              />
            </Col>
          </Row>

          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2 mb-3">
            2. Receta Óptica
          </h6>
          <Row className="text-center fw-bold mb-2 d-none d-md-flex">
            <Col md={2}></Col>
            <Col md={3}>Esfera</Col>
            <Col md={3}>Cilindro</Col>
            <Col md={2}>Eje°</Col>
            <Col md={2}>Add</Col>
          </Row>

          {/* Ojo Derecho */}
          <Row className="mb-2 align-items-center">
            <Col md={2} className="fw-bold text-end text-primary">
              OD:
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="od_e"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="od_c"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                name="od_a"
                placeholder="Eje"
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Ojo Izquierdo */}
          <Row className="mb-4 align-items-center">
            <Col md={2} className="fw-bold text-end text-primary">
              OI:
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="oi_e"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <Form.Control
                type="number"
                step="0.25"
                name="oi_c"
                placeholder="0.00"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                name="oi_a"
                placeholder="Eje"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Control
                type="number"
                step="0.25"
                name="add"
                placeholder="Add"
                onChange={handleChange}
              />
            </Col>
          </Row>

          <h6 className="text-muted text-uppercase fw-bold border-bottom pb-2 mb-3">
            3. Datos de Pago
          </h6>
          <Row className="align-items-end">
            <Col md={3}>
              <Form.Label className="fw-bold text-success fs-5">
                PRECIO TOTAL ($)
              </Form.Label>
              <Form.Control
                name="precio"
                type="number"
                required
                onChange={handleChange}
                className="form-control-lg border-success fw-bold text-success"
                placeholder="0.00"
              />
            </Col>
            <Col md={3}>
              <Form.Label>Método de Pago</Form.Label>
              <Form.Select name="metodo_pago" onChange={handleChange}>
                <option value="Efectivo">Efectivo</option>
                <option value="Transferencia">Transferencia</option>
                <option value="Un pago">Un pago</option>
                <option value="3 cuotas">3 cuotas</option>
                <option value="6 cuotas">6 cuotas</option>
              </Form.Select>
            </Col>
            <Col md={2}>
              <Form.Label>DNI</Form.Label>
              <Form.Control
                name="dni"
                onChange={handleChange}
                placeholder="DNI"
              />
            </Col>
            <Col md={2}>
              <Form.Label>Entidad</Form.Label>
              <Form.Control
                name="tarjeta"
                placeholder="Visa/Master"
                onChange={handleChange}
              />
            </Col>
            <Col md={2}>
              <Form.Label>Nro Op</Form.Label>
              <Form.Control
                name="nro_operacion"
                onChange={handleChange}
                placeholder="0000"
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="bg-light">
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={loading}
            className="px-5 fw-bold"
          >
            {loading ? "PROCESANDO..." : "REGISTRAR VENTA Y STOCK"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CargarVenta;
